"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.createStore('quickSuggestionsOption', {
    smartSuggestionsEnabled: null,
    browserLocationEnabled: null,
})();
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-quick-suggestions-option/lib/store/store.js
// module id = 3074
// module chunks = 2